import { useState } from "react";
import AuditLogTabs from "../../pages/auditLog/AuditLogTabs";
import AuditLogSideMenu from "../../pages/auditLog/AuditLogSideMenu";
import TabInTabLayoutDiv from "../4layout/adminDashboard/TabInTabLayoutDiv";

const AuditLogTemplate = () => {
    const [selectedTabIndex, setSelectedTabIndex] = useState(0);

    return (
        <TabInTabLayoutDiv tabTitle={"Audit Log"}>
            <AuditLogSideMenu
                selectedTabIndex={selectedTabIndex}
                setSelectedTabIndex={setSelectedTabIndex}
            />
            <AuditLogTabs selectedTabIndex={selectedTabIndex} />
        </TabInTabLayoutDiv>
    );
};

export default AuditLogTemplate;
